export const state = {
    loading: false,
    loaded: true,
    locale: localStorage.getItem('locale') || 'hu',
}

export const getters = {
    loaded: (state) => {
        return state.loaded
    },

    loading: (state) => {
        return state.loading
    },

    locale: (state) => {
        return state.locale
    },
}

export const mutations = {
    'SET_LOCALE': function (state, locale) {
        state.locale = locale;
        localStorage.setItem('locale', locale);
    },
}

export const actions = {
    locale: function ({commit}, locale) {
        commit('SET_LOCALE', locale);

        return Promise.resolve(locale);
    },
}
